import React, { useState } from "react";
import { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import SectionOne from "../ components/SectionOne";
import SectionTwo from "../ components/SectionTwo";
import SectionThree from "../ components/SectionThree";
import LastSection from "../ components/LastSection";
import SectionFive from "../ components/SectionFive";
import SectionFour from "../ components/SectionFour";
import Modal from "../ components/Modal";

function Home() {
  const [isModalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    navigate("/thank-you");
  };

  return (
    <div className="App relative">
      {/* Toaster for displaying toast notifications */}
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Define default options
          className: "",
          duration: 3000,
          style: {
            background: "#fff",
            color: "#363636",
          },
        }}
      />
      <div className="container mx-auto">
        <section className="text-center">
          <SectionOne openModal={openModal} />
          <SectionTwo openModal={openModal} />
          <SectionThree openModal={openModal} />
          <SectionFour openModal={openModal} />
          <SectionFive openModal={openModal} />
          <LastSection openModal={openModal} />
        </section>
        <Modal isOpen={isModalOpen} onClose={closeModal} />
      </div>
      {/* Side Sticker */}
      <div
        className="fixed right-0 top-1/3 z-50 bg-[#4F9443] text-white font-bold text-sm sm:text-base rounded-l-full cursor-pointer shadow-lg transition-all duration-300 hover:scale-105 hover:w-40 hover:py-2 flex items-center justify-center min-h-[100px]"
        onClick={openModal}
      >
        <span className="rotate-90 whitespace-nowrap">Contact Us</span>
      </div>
    </div>
  );
}

export default Home;
